export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full Stack Web Development',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Maharishi Dayanad University',
        course: 'Bachelor Degree',
        startYear: '2018',
        endYear: '2021'
    },
    // {
    //     id: 3,
    //     institution: 'Baitus Saif Islamia Madrasah',
    //     course: 'Secondary School',
    //     startYear: '2008',
    //     endYear: '2018'
    // },
]